<template>
    <div class="d-flex flex-row mb-2 pb-2" :class="{'border-bottom': borderBottom}">
        <i class="medium-icon initial-height" :class="icon"/>
        <div class="pl-3 pr-2 my-auto">
            <p class="text-muted mb-0 text-small">{{ title }}</p>
            <p class="font-weight-medium mb-0 ">{{ content }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['title', 'content', 'icon', 'borderBottom']
    }
</script>
